import { render, staticRenderFns } from "./PurchasedItemReceive30dSummary.vue?vue&type=template&id=1ed1c0c0&scoped=true"
import script from "./PurchasedItemReceive30dSummary.vue?vue&type=script&lang=js"
export * from "./PurchasedItemReceive30dSummary.vue?vue&type=script&lang=js"
import style0 from "./PurchasedItemReceive30dSummary.vue?vue&type=style&index=0&id=1ed1c0c0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed1c0c0",
  null
  
)

export default component.exports